import Heading from "@/components/tpr/Heading/Heading";
import { BreadcrumbItem, BreadcrumbLink } from "@/components/ui/breadcrumb";
import { useBreadcrumb } from "@/contexts/breadcrumbContext";
import { useEffect } from "react";
// import { useMember } from "@/contexts/memberContext";

const NotificationsView = () => {
  // const { member } = useMember();

  const { setBreadcrumb } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumb(
      <>
        <BreadcrumbItem className="text-sm text-gray-600 truncate max-w-[125px] md:max-w-none">
          <BreadcrumbLink href="#">Notifications</BreadcrumbLink>
        </BreadcrumbItem>
      </>
    );
    return () => setBreadcrumb(null);
  }, [setBreadcrumb]);

  return (
    <div>
      <div className="px-4 min-h-[80vh]">
        <div className="mb-8 mt-8">
          <Heading title={`Notifications`} />
        </div>
        <div className="flex flex-col gap-2">xxx</div>
      </div>
    </div>
  );
};

export default NotificationsView;
